import { v } from 'h3-valibot';
import {
  pdpBannerConfigurationSchema,
  type ParsedPdpBannerConfiguration
} from '~/utils/pdpBanner/configurationSchema';
import { parseRawConfigurationInput } from '~/utils/floatingContactButton/parseFloatingContactConfiguration';

export const parsePdpBannerConfiguration = (
  raw: unknown
):
  | { success: true; data: ParsedPdpBannerConfiguration }
  | { success: false; issues: v.BaseIssue<unknown>[] } => {
  const parsed = parseRawConfigurationInput(raw);
  const result = v.safeParse(pdpBannerConfigurationSchema, parsed);

  if (!result.success) {
    return { success: false, issues: result.issues };
  }

  return {
    success: true,
    data: {
      dictKey: result.output.dictKey,
      icon: result.output.icon,
      style: result.output.style,
      styleVariant: result.output.styleVariant,
      attributeConditions: result.output.attributCondtitions
    }
  };
};
